import validate from "/home/anhnq/project/personal/alobacsi/user-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45webview_45global from "/home/anhnq/project/personal/alobacsi/user-app/src/middleware/appWebview.global.ts";
import manifest_45route_45rule from "/home/anhnq/project/personal/alobacsi/user-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  app_45webview_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/anhnq/project/personal/alobacsi/user-app/src/middleware/auth.ts"),
  guest: () => import("/home/anhnq/project/personal/alobacsi/user-app/src/middleware/guest.ts")
}